import { Params } from '@angular/router';

/**
 * Stringifies the necessary query parameters for the routerLink directive.
 * Every object that is not `null` and not an array will be stringified.
 *
 * @param params The query parameters to be stringified
 * @returns The stringified query parameters
 */
export function stringifyQueryParams(params: Params): Params {
	return Object.keys(params).reduce(
		(acc, key) => ({
			...acc,
			// Wouter: Check whether the value is an object, excluding arrays and `null`. If so, stringify it. Otherwise, return the value as provided
			[key]:
				typeof params[key] === 'object' && !Array.isArray(params[key]) && params[key] !== null
					? JSON.stringify(params[key])
					: params[key]
		}),
		{}
	);
}
